module.exports = __webpack_public_path__ + "static/media/pro-detail-img1.527168b3.jpg";